import { BaseScreen, BaseGrid, BaseToolbar, ITableColumn, ICrud, CPF_MASK, CELL_PHONE_MASK, Loading } from "react-epharma-components/lib";
import React, { useState } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ExportTypes } from "react-epharma-components/lib/components/export";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faKey } from "@fortawesome/free-solid-svg-icons";
import Helpers from "@helpers";
import { UserStatusLabels } from "@enums/UserStatusEnum";
import { ILog } from "@interfaces/log";
import { ModalLog } from "@components/log";
import { ModalResetPassword } from "@components/resetPassword";
import apiClient, { getUserId } from "@services/apiClient";
import Search from "./Search";
import CrudForm from "./Crud";

const UserActivationScreen: React.FC = (props) => {
  const [showModalLog, setShowModalLog] = useState(false);
  const [log, setLog] = useState<Array<ILog>>([] as Array<ILog>);
  const [isLoading, setisLoading] = useState(false);

  const [showModalReset, setShowModalReset] = useState(false);
  const [userResetData, setUserResetData] = useState({ cpf: "", name: "" });

  const onOpenModalLog = async (userIdentity: string) => {
    setisLoading(true);
    try {
      const userId = getUserId();
      const response = await apiClient.get(Helpers.endpoints.userActivationLog + `/Read?gridParams={"page":1,"itemsPerPage":100,"filter":[{"property":"UserCpf","operator":"=","value":"${userIdentity}"}],"sorter":[]}&userId=${userId}`);
      setShowModalLog(true);
      setLog(response.data.data);
    } catch {
      setShowModalLog(false);
    } finally {
      setisLoading(false);
    }
  };

  const onOpenModalReset = (record: any) => {
    setUserResetData({
      cpf: record.cpf,
      name: `${record.name} ${record.lastName}`,
    });
    setShowModalReset(true);
  };

  const ColumnsTableGrid: ITableColumn[] = [
    {
      name: "actions",
      displayName: "Ações",
      sortable: false,
      onRender: (id, record) => (
        <div className="d-flex justify-content-center">
          <OverlayTrigger placement="top" overlay={<Tooltip id={`log-tooltip-${id}`}>Log</Tooltip>}>
            <Button variant="warning" size="sm" aria-label="Ver log" onClick={() => onOpenModalLog(record.cpf)} className="mr-1">
              <FontAwesomeIcon icon={faFileLines} size="sm" />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip id={`reset-tooltip-${id}`}>Resetar Senha</Tooltip>}>
            <Button variant="danger" className="d-none" size="sm" aria-label="Resetar senha" onClick={() => onOpenModalReset(record)}>
              <FontAwesomeIcon icon={faKey} size="sm" />
            </Button>
          </OverlayTrigger>
        </div>
      ),
      permissionId: "#CDLOGUSRAPP",
    },
    {
      name: "cpf",
      displayName: "CPF",
      sortable: false,
      mask: CPF_MASK,
    },
    {
      name: "name",
      displayName: "Nome",
      sortable: false,
    },
    {
      name: "lastName",
      displayName: "Sobrenome",
      sortable: false,
    },
    {
      name: "email",
      displayName: "E-mail",
      sortable: false,
    },
    {
      name: "mobilePhoneNumber",
      displayName: "Telefone",
      sortable: false,
      mask: CELL_PHONE_MASK,
    },
    {
      name: "birthDate",
      displayName: "Data de nascimento",
      type: "date",
    },
    {
      name: "startDate",
      displayName: "Data de cadastro",
      type: "datetime",
    },
    {
      name: "status",
      displayName: "Status",
      sortable: false,
      onRender: (value) => UserStatusLabels[value as keyof typeof UserStatusLabels],
    },
  ];

  const crud: ICrud = {
    form: <CrudForm />,
    update: {
      show: true,
      // permissionId: "#CDUPDUSRAPP",
    },
    read: {
      show: true,
    },
    exportGrid: {
      show: false,
      types: [ExportTypes.csv],
    },
  };

  return (
    <BaseScreen title="Manutenção de usuários do App" description="">
      <BaseGrid
        name="recipe"
        baseEndpoint={Helpers.endpoints.userActivation}
        toolbar={
          <BaseToolbar
            crud={crud}
            search={{
              show: true,
              form: <Search />,
            }}
          />
        }
        columns={ColumnsTableGrid}
        {...props}
      />
      <Loading hidden={!isLoading} />
      <ModalLog showModalLog={showModalLog} log={log} type="users" setShowModalLog={setShowModalLog} />
      <ModalResetPassword show={showModalReset} setShow={setShowModalReset} userCpf={userResetData.cpf} userName={userResetData.name} />
    </BaseScreen>
  );
};
export default UserActivationScreen;
